import { createTheme } from '@material-ui/core/styles';

const FlagstoneTheme = createTheme({
  typography: {
    fontFamily: "\"Helvetica\", \"Arial\", sans-serif"
  },
  palette: {
    secondary: {
      main: '#fafafa',
      secondary: '#4654FB'
    },
    primary: {
      main: '#4654FB',
      secondary: '#fafafa'
    },
    lightGreen: {
      main: '#5CC958',
      secondary: '#fafafa'
    },
    grey: {
      main: "#EFEFEF"
    },
    green: {
      main: "#5CC958"
    },
    orange: {
      main: "#F59127",
      secondary: "rgb(245, 145, 40,0.28)"
    },
    red: {
      main: "#D84949",
      secondary: "rgb(216, 73, 73,0.28)"
    }
  },
});

export default FlagstoneTheme;